export default __webpack_public_path__ + "static/media/PearlWhite.6a99fc39.svg";